import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';

import './index.scss';

export default class Campaigns extends Component {
  constructor(props) {
    super(props);
    };

  render() {
    const { auth } = this.props;
    const { domain, features } = auth;
    return (
        <div className="campaigns">
            <div className='campaigns_title'>
              <div className="campaigns_title_content">
                <div className="title">Campaigns</div>
              </div>
              <div className="campaigns_title_meta">
                <div className="icon"><i className="material-icons">help</i></div>
                <div>TrueLark offers two ways to proactively engage both new and existing guests.</div>
              </div>
            </div>
            <div className="campaigns_content">
                <div className="campaigns_content_le">
                    <div className="campaigns_content_le_title">
                       <NavLink className="nav-link" to="/app/leadengage">Lead Engage</NavLink>  
                    </div>
                    <div className="campaigns_content_le_body">
                    Lead Engage from TrueLark follows up with clients immediately via text after they submit a form, and helps them with scheduling, answering questions, and providing information — giving you the comfort of knowing that warm leads never go cold again. 
                    </div>
                    <div className="campaigns_content_le_tutorial">Feature details<a class="video-link" href={window.Config.FORM_RESPONSE.SUPPORT_VIDEO} target="_blank">here.</a></div>
                </div>
                <div className="campaigns_content_le">
                    <div className="campaigns_content_le_title">
                        <NavLink className="nav-link" to="/app/outreach">Outreach</NavLink>  
                    </div>
                    <div className="campaigns_content_le_body">
                    Outreach is a one-way, proactive communication and marketing tool that uses SMS text messaging. This feature allows you to send business updates, promotional content, and other one-way messages to opted-in contacts. Outreach supports customer communication, marketing efforts, client retention, and lead generation.
                    </div>
                    <div className="campaigns_content_le_tutorial">Feature details<a class="video-link" href={window.Config.OUTREACH_CONFIG.SUPPORT_VIDEO}  target="_blank">here.</a></div>
                </div>
            </div>
            {features && !features.includes('CONTACT_INFO_HIDDEN') && 
              <div className="help-form">Reach us at support@truelark.com or call +1-408-582-7010</div>
            }
            
        </div>
    );
  }
}

